import parse from 'html-react-parser';

import useBem from '@indicia/use-bem';

import './QuestionTitle.scss';

type PropType = {
  title: string;
  questionId: string;
};

const QuestionTitle = ({ title, questionId }: PropType) => {
  const { bemClassName } = useBem('question-title');

  return (
    <div
      className={`${bemClassName()}`}
      id={questionId}
    >
      {parse(title)}
    </div>
  );
};

export default QuestionTitle;
